module.exports = __webpack_public_path__ + "static/img/box.ecdfb09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/box.png
// module id = omNA
// module chunks = 1